import { Button, Modal } from 'react-bootstrap';


export default function ConfirmReleaseDelete({ release, show, onHide, onConfirm }) {
  if (!release) {
    return null;
  }
  return (
    <Modal className="modal-confirm" onHide={onHide} animation show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Are you sure you want to delete release "{release.title}"</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Deleting a release will permanently remove it from this release group.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>
          CANCEL
        </Button>
        <Button onClick={onConfirm} bsStyle="primary">
          DELETE RELEASE
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
